import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import './styles/designSystemV2.css';
import { Provider } from 'jotai';
import { BrowserRouter as Router } from 'react-router-dom';
import AppWrapper from './AppWrapper';
import { AppReactQueryWrapper } from './components/App/AppReactQueryWrapper';
import { SentryErrorBoundary } from './components/Sentry/SentryErrorBoundary';
import { ACLProvider } from './services/acl/acl';
import { Auth0Wrapper } from './services/Auth0Wrapper';
import { ChatSocketProvider } from './services/chatSocket';
import { ConfirmModalProvider } from './services/confirmModal';
import { DocumentHeadProvider } from './services/documentHead';
import { EntityJsonViewerProvider } from './services/entityJsonViewer';
import { ToastProvider } from './services/toast';
import MChakraProvider from './styles/MChakraProvider';
import { getAppStore } from './store/appStore';
import { ReactQueryDevtoolsWrapper } from './utils/ReactQueryDevtoolsWrapper';

export const App = () => {
  return (
    <Provider store={getAppStore()}>
      <Router>
        <AppReactQueryWrapper>
          <ReactQueryDevtoolsWrapper />
          <MChakraProvider>
            <Auth0Wrapper>
              <ToastProvider>
                <ConfirmModalProvider>
                  <EntityJsonViewerProvider>
                    <ACLProvider>
                      <DocumentHeadProvider>
                        <DndProvider backend={HTML5Backend}>
                          <SentryErrorBoundary>
                            <ChatSocketProvider>
                              <AppWrapper />
                            </ChatSocketProvider>
                          </SentryErrorBoundary>
                        </DndProvider>
                      </DocumentHeadProvider>
                    </ACLProvider>
                  </EntityJsonViewerProvider>
                </ConfirmModalProvider>
              </ToastProvider>
            </Auth0Wrapper>
          </MChakraProvider>
        </AppReactQueryWrapper>
      </Router>
    </Provider>
  );
};
